import React from 'react';
import { Chip, withStyles } from '@material-ui/core';
import scoreBadgeStyles from '../score-badge/score-badge.style';
import { SCORE_TIER, SCORE_TIER_THRESHOLDS } from '../../constants/score-tiers.constants';

const TIER_LEGEND = [
  { tier: SCORE_TIER.HIGH, label: `High ≥${SCORE_TIER_THRESHOLDS.HIGH * 100}%` },
  {
    tier: SCORE_TIER.MEDIUM,
    label: `Medium ${SCORE_TIER_THRESHOLDS.MEDIUM * 100}–89%`,
  },
  { tier: SCORE_TIER.LOW, label: `Low <${SCORE_TIER_THRESHOLDS.MEDIUM * 100}%` },
];

const ScoreTierLegend = ({ classes }) => (
  <>
    {TIER_LEGEND.map(({ tier, label }) => (
      <Chip
        key={tier}
        size="small"
        label={label}
        className={classes[tier]}
        data-testid={`score-tier-legend-${tier}`}
      />
    ))}
  </>
);

export default withStyles(scoreBadgeStyles)(ScoreTierLegend);
